// Query key factory. Filters are part of the archive key because the server
// cursor is filter fingerprinted (api-surface 2.2): a new filter set is a new
// pagination and the old cursor is dropped.

import type {
  ArchiveCallFilters,
  CandleInterval,
  ForwardHorizon,
  WorkspaceStateKind,
} from './types';

export const queryKeys = {
  authMe: () => ['auth', 'me'] as const,
  workspaces: () => ['auth', 'workspaces'] as const,
  archiveCalls: (filters: ArchiveCallFilters) => ['archive', 'calls', filters] as const,
  sourceConnectors: () => ['sources', 'connectors'] as const,
  healthReady: () => ['health', 'ready'] as const,
  callTrackerCallers: (params: { limit?: number; horizon?: ForwardHorizon; minCalls?: number }) =>
    ['call-tracker', 'callers', params] as const,
  callTrackerCalls: (params: { limit?: number }) => ['call-tracker', 'calls', params] as const,
  marketOverview: (network: string, contract: string) =>
    ['market', 'overview', network, contract] as const,
  marketRuntime: () => ['market', 'runtime'] as const,
  marketComparison: (range: string) => ['market', 'comparison', range] as const,
  researchCache: (address: string, interval?: CandleInterval) =>
    ['research', 'cache', address, interval ?? null] as const,
  researchRisk: (address: string, chain?: string) =>
    ['research', 'risk', address, chain ?? null] as const,
  coinSearch: (q: string, network?: string) =>
    ['research', 'coin-search', q, network ?? null] as const,
  workspaceState: (kind: WorkspaceStateKind) => ['state', kind] as const,
  alertsSummary: () => ['alerts', 'summary'] as const,
  searchEntities: (q: string) => ['search', 'entities', q] as const,
  archiveSearch: (q: string) => ['search', 'archive', q] as const,
  accessChallenge: () => ['auth', 'access-challenge'] as const,
  coinCatalysts: (tenantId: string | null) => ['coin-catalysts', tenantId] as const,
  coinCatalystDetail: (tenantId: string | null, eventId: string | null) =>
    ['coin-catalysts', tenantId, 'detail', eventId] as const,
} as const;
